import studentImg27 from '@/assets/images/courses/4by3/27.jpg'
import registerBannerImg from '@/assets/images/courses/4by3/29.png' 
export const cyberSecurityCourse = {
  id: 'quantum-safe-03',
  title: 'Cyber Security, Quantum & Post-Quantum Cryptography (CS-QPQC)',
  description:
    'This exclusive, one-day workshop, "Moving from Awareness to Execution," is designed specifically for Senior Security and Risk Leaders across the financial and government sectors. As quantum computing advances, the threat to current cryptographic standards becomes a critical risk. This session brings together regulators, central banks, and industry experts from Singapore, Malaysia, India, and Indonesia to drive practical, cross-border action. Participants will engage in a curated environment to bridge the gap between understanding quantum risks and implementing robust, quantum-safe migration strategies for critical infrastructure and financial services.',
  image: studentImg27,
  studentImage: studentImg27,
  badge: {
    text: 'Expert',
    class: 'bg-danger text-danger',
  },
  rating: {
    star: 4.9,
    review: 180,
  },
  students: 1300,
  lectures: 30,
  duration: 'April 24, 9:00 AM - 1:30 PM',
  //   price: 1599,
  //   originalPrice: 1999,
  //   discount: 20,
  instructor: {
    name: 'Dr. Secure Coder',
    avatar: '/images/avatar/07.jpg',
    title: 'Quantum Security Specialist',
    bio: 'Dr. Coder is an expert in post-quantum cryptography and quantum-safe systems, with over 15 years of experience in hardware security and AI defense. He has led multiple global cybersecurity training programs.',
  },
  category: {
    name: 'Quantum Cybersecurity',
  },
  registerLink: 'https://luma.com/qkywx2ei', // Added register link here
 registerImage: registerBannerImg, 
  registerImageLink: '/images/29.jpg',
  whatYouWillLearn: [
    'Gain direct insights from national cybersecurity agencies and financial regulators regarding upcoming mandates, compliance timelines, and the official strategies driving regional quantum-safe migration.',
    'Explore first-hand accounts from payment operators and commercial banks on their migration journeys, including the specific hurdles faced and the roadmaps they are utilizing.',
    'Participate in an open dialogue focused on removing blockers and identifying opportunities for international collaboration between industry leaders and regulatory bodies.',
    'Witness a live technical deep dive featuring demonstrations of quantum-safe migration scenarios specifically tailored for financial services and critical infrastructure protection.',
  ],
  status: 'Live',
  label: 'Featured',
  subject: 'Quantum Computing, Cybersecurity, Post-Quantum Cryptography',
  action: 'pending',
  videoUrl: '', // Fixed the syntax error here
  curriculum: [
    {
      title: 'Regulatory Perspectives & Mandates',
      lectures: [
        { title: 'Cybersecurity Fundamentals & CIA Triad', time: '1h' },
        { title: 'Introduction to Cryptography & Security Objectives', time: '1h' },
        { title: 'Symmetric vs Asymmetric Encryption', time: '1h' },
        { title: 'Modern Threat Models & Attack Vectors', time: '1h' },
        { title: 'Hands-on: Analyzing Cyber Threats and Vulnerabilities', time: '1h' },
      ],
    },
    {
      title: 'End-User Industry Experiences ',
      lectures: [
        { title: 'Introduction to Quantum Computing', time: '1h' },
        { title: 'Quantum Bits, Superposition, and Entanglement', time: '1h' },
        { title: 'Shor’s Algorithm: Breaking RSA & ECC', time: '1h' },
        { title: 'Grover’s Algorithm: Search Optimization', time: '1h' },
        { title: 'Quantum Key Distribution (QKD) & Quantum Communication Protocols', time: '1h' },
        { title: 'Demo: Simulating Shor’s Algorithm', time: '1h' },
      ],
    },
    {
      title: 'Cross-Border Regulator & Industry Panel',
      lectures: [
        { title: 'Understanding PQC: Why We Need It', time: '1h' },
        { title: 'Lattice-based Cryptography', time: '1h' },
        { title: 'Code-based & Hash-based Cryptography', time: '1h' },
        { title: 'Multivariate and Isogeny-based Systems', time: '1h' },
        { title: 'NIST PQC Standardization Efforts', time: '1h' },
        { title: 'Hands-on: Implementing PQC Algorithms', time: '1h' },
      ],
    },
    {
      title: 'Technical Deep Dive & Scenarios ',
      lectures: [
        { title: 'Quantum Threat Readiness Assessment', time: '1h' },
        { title: 'Hybrid Cryptographic Models (Classical + PQC)', time: '1h' },
        { title: 'Performance Evaluation of PQC Schemes', time: '1h' },
        { title: 'Integration with Existing Infrastructure', time: '1h' },
        { title: 'Regulations, Compliance, and Best Practices', time: '1h' },
      ],
    },
    {
      title: 'Strategic Action & Execution Planning',
      lectures: [
        { title: 'Capstone Project Presentation', time: '2h' },
        { title: 'Security Audit Simulation', time: '1h' },
        { title: 'Q&A with Quantum Security Experts', time: '1h' },
        { title: 'Final Certification Exam & Review', time: '1h' },
      ],
    },
  ],
  faqs: [
    {
      question: 'Who should attend this program?',
      answer: 'This program is ideal for cybersecurity professionals, cryptographers, and IT architects preparing for the quantum era.',
    },
    { question: 'Are there any prerequisites?', answer: 'Basic knowledge of cryptography and computer networks is recommended.' },
  ],
  reviews: [
    {
      name: 'Alice Quantum',
      avatar: '/images/avatar/01.jpg',
      rating: 5,
      time: new Date('2024-09-20'),
      description: 'A cutting-edge course! The blend of quantum theory and real-world security applications was exceptional.',
    },
    {
      name: 'Bob Secure',
      avatar: '/images/avatar/02.jpg',
      rating: 4.8,
      time: new Date('2024-09-22'),
      description: 'Extremely informative. The PQC deep dive was particularly well structured and practical.',
    },
  ],
}

export default cyberSecurityCourse
